import { ALERT_BASIC_REQUEST, ALERT_BASIC_SET } from "./alertBasicConstants";

export const SetAlertBasic =
  ({ type, mess = null, manualClose = false, code }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: ALERT_BASIC_REQUEST,
      });
      // if (type) {
      let obj = {
        type: type,
        mes: mess,
        manualClose: manualClose,
        code: code,
      };
      console.log("call list efect action", obj);
      dispatch({
        type: ALERT_BASIC_SET,
        payload: obj,
      });
      // }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      console.log("error basic message", message);
    }
  };
